<template>
    <div class="question_main" v-if="listCourseQuestion != null">
        <img :src="geneNetworkPicture(bigCat5BackgroundPicture.backgroundPicture)" class="big_cat_blur_backgroud"/>

        <div class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="Page_num"><div class="content_center"><span>{{questionIndex}}</span>/{{listCourseQuestion.length}}</div></div>
            <div v-if="innerPageArticleId > 0" class="action_left" @click="goInsidePages(innerPageArticleId)">
                <img src="@/assets/action_left.png"/>
                <span>内页</span>
                <div class="clear"></div>
            </div>
            <div v-bind:class="{'question_submit' :true, 'right' :canSubmit === 0, 'right_post': canSubmit === 1}"
                 :style="{'margin-top': getStateHeight()/2 + 'px'}" @click="submitClick">提交</div>
            <div class="clear"></div>
        </div>
        <audio class="audio" :src="errorAudio" id="error_audio"/>
        <audio class="audio" :src="successAudio" id="success_audio"/>
        <div class="structure_content" :style="{'padding-top':getNavCount()+'px'}" >
            <div class="question_img_content" :style="{width:getImageHeight(), height:getImageHeight()}">
                <div class="question_img">
                    <img class="img_show" v-lazy="getQuestionImg(0)"/>
                    <template v-for="(item,index) in getOptionArray()">
                        <img :id="'right_result_' + index" v-if="item.isRightAnswer === 1 && (inAnswerArray(item.pk) > -1 || isSubmit === 1)" class="img_show1"
                             :key="index" :src="$qiNiuDomainBase + item.afterSelectPicture"/>
                    </template>
                </div>
            </div>
            <div v-if="isSubmit === 0" class="option_content">
                <audio :src="audioUrl" id="musicMp3" @ended="playEnded" @error="playEnded" autoplay="autoplay"
                       controls=""/>
                <!-- 问题内容 -->
                <div class="question_content">
                    <div class="audio_play" @click="playAudio()">
                        <img src="@/Images/question_play.png" alt="" />
                    </div>
                    <div class="content">
                        <pre>{{getQuestionText()}}</pre>
                    </div>
                    <div class="chinese_english" @click="englishChineseChange">
                        <img :src="geneEnglishChinese()" alt="" />
                    </div>
                </div>
                <div class="option_img">
                    <div v-if="false" class="bubbleContainer2" @click="guideWordsAfterClick">
                        <div class="text">点图片选择</div>
                        <div class="img"><img src="@/assets/play_arrow.png"/></div>
                    </div>
                    <div class="option_img_scroll" :style="{'background-color': optionImgScrollBG}">
                        <div :id="'option_result_' + index" class="option_img_item" v-for="(item,index) in getOptionArray()" :key="index" @click="optionClick(item, index)">
                            <img class="lazy_img" v-lazy="$qiNiuDomainBase + item.picture" />
                            <div :id="'error_' + index" class="error"><img src="@/assets/error.png"/></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="question_result">
                    <div class="question_result_center">
                        <div class="right_tip"><img src="@/assets/right_tip.png"/><span>恭喜你答对了！</span></div>
                        <div class="right_content"><pre>{{getanswerText()}}</pre></div>
                    </div>
                </div>
                <div class="question_result_bottom">
                </div>
            </div>
        </div>
        <div class="transition" v-if="showTransition" @click="closeTransition">
            <div class="content">
                <img src="@/assets/transition_back.png"/>
                <div class="text">
                    <span>你已经梳理出这篇故事的结构啦！<br/>接下来，来看看本课的阅读策略讲解吧~</span>
                </div>
            </div>
            <div class="wrapper">
                <div class="wrapper-content left">
                    <div class="wrapper_back" @click="backCourseMain">
                        <span>返回课程</span>
                    </div>
                </div>
                <div class="wrapper-content left1">
                    <div class="wrapper_back" @click="nextClick">
                        <span>继续学习</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import '@/assets/animate.min.css'

    export default {
        data() {
            return {
                lessonId: 0,
                questionIndex:1,
                listCourseQuestion: [],
                bigCat5BackgroundPicture: {},
                showRightAnswerArray:[],
                canSubmit:0,
                isSubmit:0,
                noShowGuideWordsAfter:1,
                showTransition: false,
                innerPageArticleId:0,
                errorAudio: "https://img.xiaohuasheng.cn/error_tip.mp3",
                successAudio: "",
                optionImgScrollBG: "",
                showEnglishText: true,
                audioUrl: "",
            }
        },
        methods:{
            getImageHeight:function() {
                return 'calc(100vh - ' + this.getNavCount()+'px - 40px - 36px - 15vh - 30px - 20px)';
            },
            goInsidePages:function(id){
                this.$router.push({name: 'pageView', query: {url: "https://xiaohuasheng.cn/mtesthome_"+ id +"/come_1"}});
            },
            englishChineseChange: function() {
                this.showEnglishText = !this.showEnglishText;
            },
            geneEnglishChinese: function() {
                return this.showEnglishText ? require('@/Images/chinese_answer.png') : require('@/Images/english_answer.png');
            },
            guideWordsAfterClick:function(){
                let that = this;

                if (that.noShowGuideWordsAfter === 1) {
                    return;
                }

                that.$axios.get("/bigCat/saveGuidePrompt/key5").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideWordsAfter = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            submitClick:function(){
                let that = this;

                if (that.canSubmit === 0) {
                    return;
                }

                let vIsLast = that.listCourseQuestion.length === that.questionIndex;

                if (that.isSubmit === 0) {
                    that.playEnded();
                    that.showRightAnswerArray = [];
                    that.canSubmit = 1;
                    that.isSubmit = 1;
                    $(".question_submit").html(vIsLast ? "下一步" : "下一题");
                } else {
                    if (!vIsLast) {
                        that.questionIndex++;
                        that.showRightAnswerArray = [];
                        that.isSubmit = 0;
                        that.canSubmit = 0;
                        $(".question_submit").html("提交");

                        let objQuestion = that.getQuestionItem();

                        if (objQuestion == null) {
                            return "";
                        }

                        that.audioUrl = that.$qiNiuDomainBase + objQuestion.audio;

                        var t;
                        clearTimeout(t);
                        t = setTimeout(function () {
                            that.playAudio();
                        }, 400);
                    } else {
                        this.showTransition = true;
                    }
                }

                this.scrollToTop();
            },
            closeTransition:function(){
                this.showTransition = false;
            },
            backCourseMain:function(){
                this.$router.go(-1);
            },
            nextClick() {
                this.$router.go(-1);
                setTimeout(() => {
                    this.$router.push({
                        name: "SStrategy",
                        query: {
                            lessonId: this.lessonId,
                        }
                    });
                }, 0);
            },
            playErrorAudio() {
                const errorAudio = document.getElementById('error_audio');
                errorAudio.play();
            },
            playSuccessAudio() {
                const successAudioPlay = document.getElementById('success_audio');
                window.console.log(successAudioPlay);
                successAudioPlay.play();
            },
            optionClick:function(objQuestionOption, index){
                let that = this;
                let isRightAnswer = that.getCount(objQuestionOption.isRightAnswer);
                that.guideWordsAfterClick();

                // 0不是正确答案/1是正确答案
                if (isRightAnswer === 0) {
                    that.playErrorAudio();
                    $("#error_" + index).show();
                    setTimeout(function () {
                        $("#error_" + index).hide();
                    }, 500)
                    return;
                }

                let strPk = objQuestionOption.pk + '';

                if ($.inArray(strPk, that.showRightAnswerArray) > -1) {
                    return;
                }

                that.successAudio = that.$qiNiuDomainBase + objQuestionOption.audio;

                that.showRightAnswerArray.push(strPk);
                that.canSubmit = that.isAllCorrect(that.getOptionArray());

                setTimeout(function () {
                    that.playSuccessAudio();
                }, 50);

                $("#option_result_" + index).fadeOut();

                setTimeout(function () {
                    $("#right_result_" + index).attr("class", "img_show1 fadeInUp animated");
                }, 50)
            },
            inAnswerArray:function(pk) {
                let that = this;
                let strPk = pk + '';
                return $.inArray(strPk, that.showRightAnswerArray);
            },
            isAllCorrect:function(array){
                let that = this;

                if (that.isEmpty(array)) {
                    return false;
                }

                let vResult = true;

                array.forEach((item) => {
                    if (that.getCount(item.isRightAnswer) === 1 && $.inArray(item.pk + '', that.showRightAnswerArray) === -1) {
                        vResult = false;
                    }
                });

                return vResult ? 1 : 0;
            },
            getStateHeight:function(){
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount:function() {
                return this.getStateHeight() + 44;
            },
            getQuestionItem:function () {
                let that = this;
                return that.listCourseQuestion[that.questionIndex - 1]
            },
            getQuestionImg:function (isSubmit) {
                let that = this;
                let objQuestion = that.getQuestionItem();

                if (objQuestion == null) {
                    return "";
                }

                return this.$qiNiuDomainBase + (isSubmit === 1 ? objQuestion.answerPicture : objQuestion.picture);
            },
            getOptionText:function () {
                let that = this;
                let objQuestion = that.getQuestionItem();

                if (objQuestion == null) {
                    return "";
                }

                return objQuestion.text;
            },
            getQuestionText: function () {
                let that = this;
                let objQuestion = that.getQuestionItem();
                return that.showEnglishText ? objQuestion.englishQuestion : objQuestion.chineseQuestion;
            },
            getanswerText:function () {
                let that = this;
                let objQuestion = that.getQuestionItem();

                if (objQuestion == null) {
                    return "";
                }

                return objQuestion.answerText;
            },
            getOptionArray:function () {
                let that = this;
                let objQuestion = that.getQuestionItem();

                if (objQuestion == null) {
                    return [];
                }

                return objQuestion.optionArray;
            },
            scrollToTop:function () {
                window.scrollTo(0, 0);
            },
            playAudio() {
                window.console.log("开始播放");
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError != "{}") {
                            window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                        }
                    });
                } else {
                    window.console.log("播放失败:playAudio");
                }
            },
            playEnded() {
                var musicMp3 = document.getElementById('musicMp3');

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "bigCat/getLessonQuestion/" + vLessonId;

            that.$axios.get(url).then((response) => {
                that.listCourseQuestion = response.data;
                that.lessonId = vLessonId;

                if (!that.isEmpty(that.listCourseQuestion)) {
                    let vCourseQuestion = that.listCourseQuestion[0];
                    that.bigCat5BackgroundPicture = vCourseQuestion.background;
                    that.noShowGuideWordsAfter = that.getCount(vCourseQuestion.key5);
                    that.innerPageArticleId = that.getCount(vCourseQuestion.innerPageArticleId);
                    that.optionImgScrollBG = "rgba(0,0,0,0.5)";
                    that.audioUrl = that.$qiNiuDomainBase + vCourseQuestion.audio;

                    var t;
                    clearTimeout(t);
                    t = setTimeout(function () {
                        that.playAudio();
                    }, 100);
                }
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.scrollToTop();
            });
        }
    }
</script>

<style scoped>

    .question_main {
        position:absolute;
        width:100%;
        height:auto;
        min-height: 100%;
        text-align: center;
    }
    .navigation {
        position: fixed;
        width: 100%;
        z-index: 998;
    }
    .navigation .left {
        float: left;
        width: 50px;
        height: 44px;
        color: white;
        font-size: 25px;
        text-align: center;
        line-height: 50px;
    }
    .navigation .Page_num {
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
        display: inline-block;
        color: white;
        height: 44px;
        line-height: 44px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }
    .navigation .Page_num .content_center {
        display: inline-block;
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .navigation .Page_num span {
        font-size: 28px;
        font-weight: bold;
    }
    .navigation .action_left {
        margin-left: 20px;
        height: 44px;
        float: left;
    }
    .navigation .action_left img {
        width:20px;
        float: left;
        margin-right:3px;
        margin-top: 13px;
    }
    .navigation .action_left span {
        float: left;
        line-height: 44px;
        font-size: 15px;
        color: white;
    }

    .structure_content {
        position: relative;
        width: 100%;
        z-index: 997;
        display: inline-block;
    }

    .question_main .question_img_content {
        display: inline-block;
        max-width: 100%;
    }
    .question_main .question_img {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        width: 100%;
        height: 100%;
    }
    .question_main .question_img .img_show {
        width: 100%;
    }
    .question_main .question_img .img_show1 {
        position: absolute;
        width: calc(100% - 40px);
        left: 50%;
        -webkit-transform: translateX(-50%);
        opacity: 0;
    }
    audio {
        display: none;
    }
    .question_main .option_text {
        color: white;
        font-size: 20px;
        line-height:25px;
        font-weight: bold;
        margin-left: 30px;
        margin-right: 30px;
        margin-bottom: 5px;
        text-align: center;
    }

    .question_main .question_content {
        position: relative;
        display: flex;
        width: 100%;
        height: 76px;
        max-width: 590px;
        margin: 0 auto;
    }

    .question_main .question_content .audio_play {
        position: relative;
        margin-left: 20px;
        z-index:600;
    }

    .question_main .question_content .audio_play img {
        width: 40px;
        height: 40px;
        margin-top: 18px;
    }
    .question_main .question_content .content {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        z-index:599;
        width: calc(100% - 73px);
        height: 100%;
        margin-left: -20px;
        margin-right: -13px;
        background-color: #FFAA00;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        text-align: left;
        align-items: center;
        align-content: center;
    }
    .question_main .question_content .content pre {
        margin-left: 30px;
        margin-right: 15px;
        font-size: 17px;
        color: white;
        white-space:pre-wrap;
        white-space:-moz-pre-wrap;
        white-space:-pre-wrap;
        white-space:-o-pre-wrap;
        word-wrap:break-word;
    }
    .question_main .question_content .chinese_english {
        position: relative;
        float: right;
        margin-right: 20px;
        z-index:598;
    }

    .question_main .question_content .chinese_english img {
        width: 40px;
        height: 40px;
        margin-top: 18px;
    }

    .option_img {
        position: relative;
    }
    .option_img .option_img_scroll {
        display: flex;
        overflow-y: hidden;
        overflow-x: scroll;
        margin-top: 20px;
        padding: 15px 0px 15px 15px;
    }
    .option_img .option_img_scroll::-webkit-scrollbar {
        display: none;
    }
    .option_img .option_img_scroll .option_img_item {
        display: flex;
        position:relative;
        padding-right: 15px;
        margin-bottom: 0;
    }
    .option_img .option_img_scroll .option_img_item .lazy_img {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: 15vh;
        height:15vh;
        padding: 0;
        margin: 0;
        background-color: white;
    }
    .option_img .option_img_scroll .option_img_item .checked_img {
        position: absolute;
        top: 0;
        right: 0;
        display: block;
        width: 23px;
        margin-right: 5px;
        margin-top: 5px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .option_img .option_img_scroll .option_img_item .error {
        position: absolute;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        width: calc(100% - 14px);
        height: 100%;
        border-radius: 9px;
        -webkit-border-radius: 9px;
        -moz-border-radius: 9px;
        display: none;
    }
    .option_img .option_img_scroll .option_img_item .error img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .question_result_bottom {
        height: 30px;
    }
    .question_result {
        position: relative;
        width: calc(100% - 60px);
        background-color: white;
        margin-left: 30px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .question_result_center {
        position: relative;
        width: 100%;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .question_result .right_tip {
        display:inline-block;
    }
    .question_result .right_tip img {
        float: left;
        width: 50px;
        height: 50px;
    }
    .question_result .right_tip span {
        float: left;
        line-height: 50px;
        font-size: 20px;
        font-weight: bold;
        color: #369e54;
        margin-top: 5px;
        margin-left: 5px;
    }
    .question_result .right_content {
        font-size: 18px;
        margin-left: 15px;
        margin-right: 15px;
    }

    .right_content pre {
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 9999;
    }
    .transition .content {
        position: relative;
        background-color: transparent;
        text-align: center;
        z-index: 10000;
    }
    .transition .content img {
        margin-top: 50px;
        margin-bottom: 50px;
        width: 100%;
        height: auto;
    }
    .transition .content .text {
        width: 100%;
        position: absolute;
        bottom: 0;
    }
    .transition .content span {
        width: 100%;
        color: white;
        font-size: 18px;
        font-weight: bold;
        line-height: 30px;
    }
    .wrapper {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .wrapper-content {
        width: 50%;
        text-align: center;
        margin-top: 60px;
    }
    .wrapper .left {
        padding-left: calc((100% - 300px)/3);
    }
    .wrapper .left1 {
        padding-left: calc((100% - 300px)/6);
    }
    .wrapper_back {
        width: 150px;
        height: 40px;
        text-align: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        background-color: #3b9c55;
    }
    .wrapper_back span {
        color: white;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }
    .navigation .right {
        width: 80px;
        height: 30px;
        float: right;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform:translateY(-50%);
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
        background-color: #d4d4d4;
        font-size: 16px;
        font-weight: bold;
        color: #999999;
        text-align: center;
        line-height: 30px;
    }
    .navigation .right_post {
        width: 80px;
        height: 30px;
        float: right;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform:translateY(-50%);
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
        background-color: #FFAA00;
        font-size: 16px;
        font-weight: bold;
        color: white;
        text-align: center;
        line-height: 30px;
    }
    .bubbleContainer2{
        position: absolute;
        top: -33px;
        left: calc((100% - 105px)/2);
        padding-bottom: 12px;
        z-index: 999;
    }
    .bubbleContainer2 .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer2 .img {
        position: absolute;
        bottom: 0;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer2 .img img {
        width: 12px;
    }
    .option_content {
        position: relative;
        bottom: 0;
    }
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform:translate(-50%, 100px);
        }

        to {
            opacity: 1;
            transform:translate(-50%, 0);
        }
    }
    .fadeInUp {
        animation-name: fadeInUp;
    }

</style>